export enum AuthenticationMethod {
    NONE = 'none',
    MSAL = 'msal',
    JWT = 'jwt'
};